import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CardImage from "../CardImage";

import "./storyHeroImage.m.css";

const StoryHeroImage = ({ story, imageWidth = [900], lang }) => {
  return (
    <div styleName="card-image">
      <div>
        <CardImage
          story={story}
          defaultWidth={760}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          widths={imageWidth}
          showStoryTypeIcon={false}
          showAlternateImage={false}
        />
      </div>
      {story["hero-image-caption"] && (
        <div styleName="image-caption">
          <figcaption className="story-element-image-caption">
            {story["hero-image-caption"]}
            {story["hero-image-attribution"] && <span styleName={`attribute`}>{story["hero-image-attribution"]}</span>}
          </figcaption>
        </div>
      )}
    </div>
  );
};

StoryHeroImage.propTypes = {
  story: object.isRequired,
  imageWidth: array,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", ""], ""),
});

export default connect(mapStateToProps, null)(StoryHeroImage);
